module.exports = __webpack_public_path__ + "static/media/banner-logp.acc2df1b.png";